import { Component } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProductCategoryService, ProductCategoryCreateInput } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN } from 'src/app/shared/constants/operationals';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-product-category-new-category-dialog',
  templateUrl: './product-category-new-category-dialog.component.html',
  styleUrls: ['./product-category-new-category-dialog.component.scss'],
})
export class ProductCategoryNewCategoryDialogComponent {
  product_category_new_category_from_group: FormGroup = this.form_service.product_category_new_category_from_group;
  is_submit_running: boolean = false;
  default_lengths: number[] = PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<ProductCategoryNewCategoryDialogComponent>,
    private form_service: FormService,
    private product_category_service: ProductCategoryService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {}

  ngOnInit(): void {
    this.product_category_new_category_from_group.reset();
    this.buildProductCategoryForm();
  }

  buildProductCategoryForm(): void {
    this.product_category_new_category_from_group = this.product_category_service.buildProductCategoryForm(
      this.product_category_new_category_from_group,
      this.default_lengths,
    );
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.product_category_new_category_from_group);
  }

  getInstallmentPlans(): FormArray {
    return this.product_category_new_category_from_group.get(
      this.form_service.product_category_installment_plans_label,
    ) as FormArray;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSubmitClick(): void {
    if (this.isFormValid()) {
      const name: string = this.product_category_new_category_from_group.get(
        this.form_service.product_category_name_label,
      )?.value;

      const decido_evaluation_code: string = this.product_category_new_category_from_group.get(
        this.form_service.product_category_decido_evaluation_code_label,
      )?.value;

      const first_subcategory: string = this.product_category_new_category_from_group.get(
        this.form_service.product_category_first_subcategory_label,
      )?.value;

      const form_installment_plans = this.product_category_new_category_from_group.get(
        this.form_service.product_category_installment_plans_label,
      )?.value;

      const installment_plans = form_installment_plans?.map((plan: any) => ({
        plan_length: plan.plan_length,
        step_0_tax_percentage: Number(plan.step_0_tax_percentage),
      }));

      const params: ProductCategoryCreateInput = {
        name: name || undefined,
        decido_evaluation_code: decido_evaluation_code || undefined,
        sub_category_collection: [{ name: first_subcategory }],
        installment_plans: installment_plans || undefined,
      };

      this.createProductCategory(params);
    }
  }

  createProductCategory(product_category: ProductCategoryCreateInput): void {
    this.is_submit_running = true;
    this.product_category_service.createProductCategory(product_category).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_submit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_submit_running = false;
      },
    });
  }

  hasStepZeroMaxPercError(step_0_tax_percentage_label: string, index: number): boolean | undefined {
    return this.utils_service.hasStepZeroMaxPercError(
      this.getInstallmentPlans().at(index) as FormGroup,
      step_0_tax_percentage_label,
    );
  }

  getStepZeroMaxPercFormFieldErrorClass(
    step_0_tax_percentage_label: string,
    index: number,
  ): {
    [key: string]: boolean | undefined;
  } {
    return this.utils_service.getStepZeroMaxPercFormFieldErrorClass(
      this.getInstallmentPlans().at(index) as FormGroup,
      step_0_tax_percentage_label,
    );
  }
}
